import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import { Map as ImmutableMap } from 'immutable';
import { clearAlert } from '../actions/AlertActions';
import { getAlerts } from '../selectors/EntitySelector';
import Alerts from '../components/Alerts';
import { jsx as _jsx } from "react/jsx-runtime";
class AlertsContainer extends Component {
  constructor(props) {
    super(props);
    this.onClearAlert = this.onClearAlert.bind(this);
  }
  onClearAlert(alertId) {
    this.props.clearAlert(alertId);
  }
  render() {
    const {
      activeAlerts
    } = this.props;
    return /*#__PURE__*/_jsx(Alerts, {
      activeAlerts: activeAlerts,
      onClearAlert: this.onClearAlert
    });
  }
}
AlertsContainer.propTypes = {
  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'typeof Map' is not assignable to... Remove this comment to see the full error message
  activeAlerts: PropTypes.instanceOf(ImmutableMap).isRequired,
  clearAlert: PropTypes.func.isRequired
};
const mapStateToProps = state => {
  return {
    activeAlerts: getAlerts(state)
  };
};
export default connect(mapStateToProps, {
  clearAlert
})(AlertsContainer);